import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { BUSINESS } from "@/data/policies";

let cache = null;

const FALLBACK = {
  legalName: BUSINESS.legalName,
  email: BUSINESS.email,
};

export function useBusiness() {
  const [biz, setBiz] = useState(cache || FALLBACK);

  useEffect(() => {
    if (cache) return;
    axios
      .get(`${API}/business`)
      .then(({ data }) => {
        cache = {
          legalName: data.legal_name,
          email: data.email,
        };
        setBiz(cache);
      })
      .catch(() => {});
  }, []);

  return biz;
}
